class LoadNonceError extends Error {
  constructor() {
    super(`Failed to load nonce.`)
    this.name = 'LoadNonceError'
  }
}

export default LoadNonceError
